import { Button } from "@/components/ui/button";
import { RefreshCw, X, Trash2 } from "lucide-react";
import { clearAllCachesAndRefresh } from "@/utils/cacheUtils";
import { useState } from "react";

interface UpdateBannerProps {
  onUpdate: () => void;
  onDismiss?: () => void;
}

export function UpdateBanner({ onUpdate, onDismiss }: UpdateBannerProps) {
  const [isClearing, setIsClearing] = useState(false);

  const handleForceUpdate = async () => {
    setIsClearing(true);
    await clearAllCachesAndRefresh();
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-primary text-primary-foreground shadow-lg">
      <div className="max-w-md mx-auto px-4 py-3 flex items-center justify-between gap-2">
        <p className="text-sm font-medium flex-1">
          New version available
        </p>
        <div className="flex items-center gap-2 flex-shrink-0">
          <Button 
            onClick={onUpdate} 
            size="sm" 
            variant="secondary"
            className="gap-1"
          >
            <RefreshCw className="h-3 w-3" />
            <span className="hidden sm:inline">Refresh</span>
          </Button>
          <Button 
            onClick={handleForceUpdate} 
            size="sm" 
            variant="secondary"
            disabled={isClearing}
            className="gap-1"
          >
            <Trash2 className="h-3 w-3" />
            <span className="hidden sm:inline">{isClearing ? "..." : "Clear Cache"}</span>
          </Button>
          {onDismiss && (
            <Button 
              onClick={onDismiss} 
              size="sm" 
              variant="ghost"
              className="h-8 w-8 p-0"
            >
              <X className="h-4 w-4" />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
